import { createContext, useContext, useState, ReactNode } from 'react';
import { Snackbar, SnackbarProps } from 'neon-design-system';
import { v4 as uuid } from 'uuid';

interface SnackbarData extends SnackbarProps {
  key: string;
}

interface SnackbarContextData {
  snackbarContainer: ReactNode;
  showSnackbar: (message: string, type?: SnackbarProps['type']) => void;
}

const SnackbarContext = createContext<SnackbarContextData | undefined>(undefined);

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};

export const SnackbarProvider = ({ children }: React.Props<undefined>) => {
  const [snackbar, setSnackbar] = useState<SnackbarData | undefined>(undefined);

  const showSnackbar = (message: string, type: SnackbarProps['type'] = 'info') => {
    setSnackbar({
      message,
      autoHideDuration: 5000,
      open: true,
      key: uuid(),
      type
    });
  };

  const snackbarContainer = snackbar && <Snackbar {...snackbar} onClose={() => setSnackbar({ ...snackbar, open: false })}></Snackbar>;

  return <SnackbarContext.Provider value={{ showSnackbar, snackbarContainer }}>{children}</SnackbarContext.Provider>;
};
